import { ReactComponent as ErrorIcon } from "@/Images/icons/Error.svg"
import { FormattedMessage } from "react-intl"

export const Error = ({ title, msg }: { title?: string; msg: string }) => {
  return (
    <div className="top-error">
      <ErrorIcon />
      <h1>{title ?? <FormattedMessage id="error" />}</h1>
      <p>{msg}</p>
    </div>
  )
}
